import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { tokenDecode } from "../../utils/helper";
import ThemeMaker from "../thememaker";
import "./InactiveAccount.css";


// Shown when user account is pending approval (approve_status=0, seller_id=null)
const InactiveAccountScreen = () => (
    <>
        {/* Invisible overlay — blocks all sidebar link clicks */}
        <div className="ias__sidebar-blocker" />

        <ThemeMaker>
            <div className="ias__wrapper">

                {/* Page Header */}
                <div className="ias__header">
                    <div>
                        <h5 className="ias__header-title">Dashboard</h5>
                        <p className="ias__header-subtitle">Account status overview</p>
                    </div>
                    <span className="ias__badge">
                        <span className="ias__badge-dot" />
                        Pending Approval
                    </span>
                </div>

                {/* Content */}
                <div className="ias__content">
                    <div className="ias__card">
                        <div className="ias__card-strip" />
                        <div className="ias__card-body">

                            {/* Lock Icon */}
                            <div className="ias__icon">🔒</div>

                            <h5 className="ias__card-title">Account Not Activated</h5>

                            <p className="ias__card-desc">
                                Your account is <span>pending approval</span> from admin.<br />
                                Once approved, you'll have full access to the dashboard.
                            </p>

                            {/* Info Box */}
                            <div className="ias__info-box">
                                <span className="ias__info-box-icon">📬</span>
                                <span className="ias__info-box-text">
                                    Contact your <strong>Admin / Seller</strong> to get your account activated
                                </span>
                            </div>

                            {/* Logout Button */}
                            <button
                                className="ias__logout-btn"
                                onClick={() => {
                                    sessionStorage.removeItem("token");
                                    sessionStorage.removeItem("is_activated");
                                    sessionStorage.removeItem("seller_approved");
                                    sessionStorage.removeItem("isSkipped");
                                    window.location.href = "/";
                                }}
                            >
                                Logout
                            </button>

                        </div>
                    </div>
                </div>

            </div>
        </ThemeMaker>
    </>
);

const ProtectedRoute = ({ children }: any) => {

    const history = useHistory();
    const location = useLocation();
    const search = useLocation().search;
    const tk_access = new URLSearchParams(search).get('tk_access');

    const denied = () => {
        toast.error("You do not have permission to access this page", {
            toastId: "no_permission_toast"
        });
        history.push("/dashboard");
        return null;
    };

    // const token: any = sessionStorage.getItem("token");
    // const TokenChecker = async () => {
    //     try {
    //         const { data } = await axios({
    //             url: "/login/refresh",
    //             method: "POST",
    //             headers: {
    //                 "x-custom-authorization": `Bearer ${token}`
    //             }
    //         });
    //         sessionStorage.setItem("isLogedIn", data.refreshToken);
    //     } catch (error) {
    //         sessionStorage.removeItem("isLogedIn");
    //     }
    // }
    useEffect(() => {
        //   TokenChecker();
    }, []);
    const keyV = location.pathname.split("/")[1];
    try {

        const decoded: any = tokenDecode();
        console.log("decoded data::", decoded)
        console.log("decoded", decoded);
        console.log("decoded.data", decoded?.data);
        console.log("decoded.payload", decoded?.payload);

        const { data } = decoded || {};

        // --- INACTIVE / ONBOARDING ACCOUNT CHECK ---
        const userObj = Array.isArray(data?.user) ? data.user[0] : (data?.user || {});
        const sellerObj = Array.isArray(data?.seller_data) ? data.seller_data[0] : (data?.seller_data || {});
        const approveStatus = userObj?.approve_status !== undefined && userObj?.approve_status !== null
            ? userObj?.approve_status
            : sellerObj?.approve_status;
        const sellerId = userObj?.seller_id || sellerObj?.id;
        const isRootAdmin = String(userObj?.parent_id) === "0" || Number(sellerId) === 1 || Number(userObj?.id) === 1;

        // Check whether user has already completed KYC
        const isKycDone = Boolean(
            userObj?.kyc_status === true ||
            userObj?.kyc_status === "true" ||
            userObj?.kyc_status === 1 ||
            sellerObj?.kyc_status === true ||
            sellerObj?.kyc_status === "true" ||
            sellerObj?.kyc_status === 1
        );

        if (!isRootAdmin) {
            if (!isKycDone) {
                // Case 1: New/pending user whose KYC is incomplete -> must complete KYC onboarding
                const isKycRoute = keyV.toLowerCase() === "sellerdetails_kyc";
                const isSkipped = sessionStorage.getItem("isSkipped") === "true";
                if (!isKycRoute && !isSkipped) {
                    history.push("/Sellerdetails_kyc");
                    return null;
                }
            } else if (approveStatus === 0 || approveStatus === "0" || approveStatus === false) {
                // Case 2: KYC is completed, but admin hasn't approved the seller yet -> show Inactive screen
                return <InactiveAccountScreen />;
            }
        }
        // --- END CHECK ---

        const current_sellerid = Number(data?.user?.[0]?.seller_id || data?.user?.seller_id || 1);

        const getP = (tab: any) => {
            if (Array.isArray(data?.permission)) {
                const permArray = typeof data.permission.flat === "function" ? data.permission.flat() : data.permission;
                const perm = permArray.find((p: any) => p?.tab_name === tab);
                if (!perm) return { read: true, write: true, update: true, delete: true };
                return {
                    read: perm.p_read ?? true,
                    write: perm.p_write ?? true,
                    update: perm.p_update ?? true,
                    delete: perm.p_delete ?? true,
                };
            }
            const permObj = data?.permission?.[tab];
            if (permObj) {
                return {
                    read: permObj.p_read ?? permObj.read ?? true,
                    write: permObj.p_write ?? permObj.write ?? true,
                    update: permObj.p_update ?? permObj.update ?? true,
                    delete: permObj.p_delete ?? permObj.delete ?? true,
                };
            }
            return { read: true, write: true, update: true, delete: true };
        };

        const category = getP("category");
        const order = getP("order");
        const product = getP("product");
        const role = getP("role");
        const seller = getP("seller");
        const tax = getP("tax");
        const user = getP("user");
        const location = getP("location");
        const product_master_catalog = getP("product_master_catalog");
        const igm = getP("igm");
        const transaction = getP("transaction");
        // console.log("hhhh", decoded);

        if (decoded) {
            // if (isAdmin === "true") {
            //     return children;
            // }
            switch (keyV) {
                case "":
                    return children;
                case "dashboard":
                    return children;
                case "addseller":
                    return (current_sellerid < 2 && (seller.write || isRootAdmin)) ? children : denied();
                case "sellerlist":
                    return (current_sellerid < 2 && seller.read) ? children : denied();
                case "tax":
                    return (current_sellerid < 2 && tax.write) ? children : denied();
                case "Sellerdetails_kyc":
                case "sellerdetails_kyc":
                    return children;
                case "updateseller":
                    return (current_sellerid < 2 && (seller.update || isRootAdmin)) ? children : denied();
                case "roles":
                    return role.write ? children : denied();
                case "adduser":
                    return user.write ? children : denied();
                case "addwarehouse":
                    return user.write ? children : denied();
                case "addvariants":
                    return user.write ? children : denied();
                case "variantslist":
                    return user.read ? children : denied();
                case "sellerDetails":
                    return user.write ? children : denied();
                case "warehousefulfillment":
                    return user.write ? children : denied();
                case "warehouseserviceability":
                    return user.write ? children : denied();
                case "updateuser":
                    return user.update ? children : denied();
                case "userlist":
                    return user.read ? children : denied();
                // case "category":
                //     return category.write ? children : denied();
                case "product":
                    return product.write ? children : denied();
                case "productlist":
                    return (product.read || category.read) ? children : denied();
                case "orderlist":
                    return order.read ? children : denied();
                case "orderdetails":
                    return order.read ? children : denied();
                case "transaction":
                    return transaction.read ? children : denied();
                case "payments":
                    return transaction.read ? children : denied();
                case "location":
                    return location.read ? children : denied();
                case "returnorders":
                    return order.read ? children : denied();
                case "issues":
                    return igm.read ? children : denied();
                case "onissues":
                    return igm.read ? children : denied();
                case "grievancesettings":
                    return igm.read ? children : denied();
                case "grievance-list":
                    return igm.read ? children : denied();
                case "ticketsupport":
                    return igm.read ? children : denied();
                case "ticketsupportlist":
                    return igm.read ? children : denied();
                case "ondclistedproduct":
                    return product.read ? children : denied();
                case "producttypelist":
                    return current_sellerid < 2 ? children : denied();
                case "producttype":
                    return current_sellerid < 2 ? children : denied();

                case "mastercatalog":
                    return children;
                case "buyerfee":
                    return current_sellerid < 2 ? children : denied();
                case "logrejection":
                    return children;
                case "masterproductlist":
                    return children;
                case "ondcsellerproduct":
                    return children;
                case "ondcsellerproductadd":
                    return children;
                case "nonapprovedproducts":
                    return children;
                case "nonapprovedproducts":
                    return children;
                case "nonapprovedproduct":

                    return children;
                case "serviceability":
                    return children;
                case "notifications":
                    return children;
                case "sellernonapprovedproducts":
                    return children;
                case "test":
                    return children;

                case "profile":
                    return children;
                case "sellerdetail":
                    return children;
                case "logs":
                    return children;
                case "sidebar":
                    return children;
                case "onboardingform":
                    return children;
                case "ondcsellerapp":
                    return children;
                case "resetpassword":
                    return children;
                case "selleregister":
                    return children;
                case "personaldetails":
                    return children;
                case "bankdetails":
                    return children;
                case "checkseller":
                    return children;
                case "pending":
                    return children;

                case "catalog":
                    return product.read ? children : denied();
                case "productcatalog":
                    return product.read ? children : denied();
                case "instorecatalog":
                    return product.read ? children : denied();
                case "createproduct":
                    return product.read ? children : denied();
                case "order":
                    return order.read ? children : denied();

                case "allorderslist":
                    return children;
                case "orderCompleteDetail":
                    return order.read ? children : denied();
                case "orderCompleteinfo":
                    return order.read ? children : denied();
                case "customerorder":
                    return order.read ? children : denied();
                case "completeOrder":
                    return order.read ? children : denied();
                case "cancelOrderlist":
                    return order.read ? children : denied();
                case "unsettledtransactions":
                    return transaction.read ? children : denied();
                case "findproduct":
                    return transaction.read ? children : denied();
                case "brand":
                    return current_sellerid < 2 ? children : denied();
                case "sellerauthcheck":
                    return children;
                case "newcategory":
                    return current_sellerid < 2 ? children : denied();
                case "subcategory":
                    return children;
                case "seeorderdetails":
                    return children;
                case "acceptedorderdetail":
                    return children;
                case "orderpopup":
                    return children;
                case "updatestoreproduct":
                    return children;
                case "invoice":
                    return children;
                case "order_invoice":
                    return children;
                case "supportlist":
                    return children;
                case "rspdashboard":
                    return children;
                case "updatepassword":
                    return children;
                case "settings":
                    return children;
                case "inventoryless":
                    return children;
                case "socialtagging":
                    return children;
                case "loglist":
                    return children;
                case "ondcsaleschannel":
                    return children;
                case "raiseissue":
                    return children;
                case "issueslists":
                    return children;
                case "terms":
                    return children;
                case "termandconditions":
                    return children;
                case "terms-and-conditions":
                    return children;
                default:
                    return history.push("/dashboard");
            }

        } else {
            console.log("no");
            switch (keyV) {
                case "forget-password":
                    return children;
                case "reset-password":
                    return children;
                default:
                    return history.push("/");
            }
        }
    } catch (error) {
        console.log("this erro -->", error);

        switch (keyV) {
            case "forget-password":
                return children;
            case "reset-password":
                return children;
            case "test":
                return children;
            default:
                return history.push("/");
        }
    }
}


export default ProtectedRoute;
